import type { StrictOmit } from '@frontend/duck-tape';
import { isString } from '@frontend/duck-tape';
import type { ReactNode } from '@frontend/react';
import { XStack } from '../Containers';
import type { TextProps } from '../Texts/Text';
import { Text } from '../Texts/Text';

export type InputLabelProps = {
  inverse?: boolean;
  label: ReactNode;
  showOptionalText?: boolean;
  textProps?: StrictOmit<TextProps, 'children'>;
};

export const InputLabel = ({ inverse = false, label, showOptionalText = false, textProps }: InputLabelProps) => {
  return (
    <XStack className="flex-1 justify-between">
      {isString(label) ? (
        <Text color={inverse ? 'inverse' : 'primary'} {...textProps}>
          {label}
        </Text>
      ) : (
        label
      )}
      {showOptionalText ? <Text color={inverse ? 'inverse' : 'secondary'}>Optional</Text> : null}
    </XStack>
  );
};
